
import { Document, Page, Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer';

const PayslipPDF = ({ data }) => {
    const pname = data.tutorName;

    let totalAmount = 0;
    for (let i = 0; i < data.classList.length; i++) {
        totalAmount += Math.round(data.classList[i].payment)
    }
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Image source={require('../../images/gradient.png')} style={{ height: 20, width: "150%", position: 'absolute', top: 0 }} />
                <Image source={require('../../images/gradient.png')} style={{ height: 20, width: "150%", position: 'absolute', bottom: 0 }} />
                <View style={{ height: 150 }}>
                    {/* <View style={{ alignItems: 'center', backgroundColor: "#FFA500", marginVertical: 10 }}>
                        <Text style={{ color: "white" }}>INVOICE</Text>
                    </View> */}
                    <Text style={{ fontSize: 14, fontFamily: 'Times-Bold', color: "#E56717", marginTop: 30 }}>SLIP BAYARAN</Text>
                    <Text style={{ fontSize: 10, fontFamily: 'Helvetica' }}>REF: PTGM/AL/TM/PJ03</Text>
                    <Text style={{ fontSize: 10, fontFamily: 'Helvetica' }}>PUSAT TUISYEN GENIUS MILENIA</Text>
                    <Text style={{ fontSize: 10, fontFamily: 'Helvetica' }}>NO 1-1 PJCC TAMAN MEDAN, PETALING JAYA</Text>
                    <Text style={{ fontSize: 10, fontFamily: 'Helvetica' }}>03-77732751</Text>
                    <Image source={require('../../images/GME-Logo.png')} style={{ height: 100, width: 130, position: 'absolute', right: 30, top: 35, objectFit: "contain" }} />
                </View>
                <View style={{ marginBottom: "20px" }}>
                    <Text style={{ fontSize: 10, fontFamily: 'Helvetica-Bold' }}>ENCIK/PUAN,</Text>
                    <Text style={{ fontSize: 10, fontFamily: 'Helvetica-Bold' }}>{pname ? pname.toUpperCase() : " "}</Text>
                </View>
                <View style={styles.table}>
                    <View style={[styles.row, styles.bold, styles.header]}>
                        <Text style={[styles.col1, { fontFamily: 'Helvetica-Bold' }]}>No</Text>
                        <Text style={[styles.col2, { fontFamily: 'Helvetica-Bold' }]}>Date</Text>
                        <Text style={[styles.col4, { fontFamily: 'Helvetica-Bold' }]}>Class</Text>
                        <Text style={[styles.col4, { fontFamily: 'Helvetica-Bold' }]}>Remarks</Text>
                        <Text style={[styles.col2, { fontFamily: 'Helvetica-Bold' }]}>Rate</Text>
                    </View>
                    {data?.classList.map((row, i) => (
                        <View key={i} style={styles.row} wrap={false}>
                            <Text style={styles.col1}>{i + 1}</Text>
                            <Text style={styles.col2}>{row.date || "-"}</Text>
                            <Text style={styles.col4}>{row.courseName || "-"}</Text>
                            <Text style={styles.col4}>{row.remarks || "-"}</Text>
                            <Text style={styles.col2}>RM{(parseInt(row.payment)).toFixed(2).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</Text>
                        </View>
                    ))}
                    <View style={styles.row} wrap={false}>
                        <Text style={styles.col1}></Text>
                        <Text style={styles.col2}></Text>
                        <Text style={styles.col4}></Text>
                        <Text style={[styles.col4, { fontFamily: 'Helvetica-Bold', textAlign: "right" }]}>Total:</Text>
                        <Text style={[styles.col2, { fontFamily: 'Helvetica-Bold', borderBottom: '1px solid #e0e0e0' }]}>RM{totalAmount.toFixed(2).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</Text>
                    </View>
                </View>
                <View style={{ width: "100%", margin: 20, marginTop: 30 }}>
                    <View style={{ flexDirection: "row" }}>
                        <Text style={{ fontSize: 10, fontFamily: 'Helvetica-Bold', marginBottom: "5px" }}>Bank Name: </Text>
                        <Text style={{ fontSize: 10, fontFamily: 'Helvetica', marginBottom: "5px" }}>{data?.bankName}</Text>
                    </View>
                    <View style={{ flexDirection: "row" }}>
                        <Text style={{ fontSize: 10, fontFamily: 'Helvetica-Bold', marginBottom: "5px" }}>Account No: </Text>
                        <Text style={{ fontSize: 10, fontFamily: 'Helvetica', marginBottom: "5px" }}>{data?.accountNo}</Text>
                    </View>
                </View>
                <View style={{ height: 70 }} />
                <View style={{ width: "100%", position: "absolute", bottom: 30, margin: 20 }}>
                    <View>
                        <Text style={{ fontSize: 10, fontFamily: 'Helvetica', marginTop: 20, textAlign: "center" }}>Thank you.</Text>
                        <Text style={{ fontSize: 10, fontFamily: 'Times-Italic', textAlign: "center" }}>‘Excellent Learning Experience’</Text>
                    </View>
                </View>
            </Page>
        </Document>

    )
};

export default PayslipPDF;

Font.register({
    family: 'Open Sans',
    fonts: [
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600, fontStyle: "italic" }
    ]
});

// Create styles
const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white',
        padding: 20
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
    table: {
        width: '100%'
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #e0e0e0',
        paddingTop: 8,
        paddingBottom: 8,
    },
    header: {
        borderTop: 'none',
        backgroundColor: "#e0e0e0"
    },
    bold: {
        fontWeight: 'bold',
    },
    // So Declarative and unDRY 👌
    col1: {
        width: '10%',
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "5px"
    },
    col2: {
        width: '20%',
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "5px",
        textAlign: "center"
    },
    col3: {
        width: '30%',
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "5px",
        textAlign: "center"
    },
    col4: {
        width: '40%',
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "5px",
        textAlign: "center"
    },
    col5: {
        width: '50%',
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "5px",
        textAlign: "center"
    }
});